import ConsumerItemsService from "@api/consumer/consumerItemsService";
import { EditItemForm } from "@components/consumer/items";
import { useBreadcrumbs, useStateLoader } from "@hooks/panelHooks";
import { IItemFull } from "@interfaces/consumer/items";
import { useCallback } from "react";
import { useParams } from "react-router";
import { Card, Spinner } from "react-bootstrap";
import withPage from "@components/hoc/withPage";

const EditItemPage: React.FC = () => {

    const { item_id } = useParams<{ item_id: string }>();

    const loadItem = useCallback(() => {
        const api = new ConsumerItemsService();
        return api.getItem(item_id || '')
    }, [item_id]);
    const { data: item, loading } = useStateLoader<IItemFull>(loadItem);

    useBreadcrumbs('consumer.item.current.name', true, item?.name);

    if (!item) {
        return (
            <Card>
                <Card.Body className="text-center">
                    {loading ? <Spinner className="mr-2" color="primary" /> : (
                        "Предмет не найден"
                    )}
                </Card.Body>
            </Card>
        )
    }

    return (
        <EditItemForm item={item} />
    )
}

export default withPage(EditItemPage);